import React from 'react';
import PropTypes from 'prop-types';
import { isTjkPlayDisable } from 'Store/constants/horseRacing';

const TjkPlayableFlag = ({ children })  => {
  if (isTjkPlayDisable()) {
    return null;
  }

  return <>{ children }</>;
};

TjkPlayableFlag.propTypes = {
  children: PropTypes.any,
};

export default TjkPlayableFlag;
